module.exports = __webpack_public_path__ + "fonts/MoskauGrotesk-Light.b0c062d5.woff2";